import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IClassifier } from '../../../models/Classifier';
import { AppService } from '../../../services/app.service';
import { CourseEqualizationService } from '../../../services/course-equalization.service';

@Component({
    selector: 'app-course-equalization-approval',
    templateUrl: './course-equalization-approval.component.html'
})
export class CourseEqualizationApprovalComponent {
    constructor(
        private app: AppService,
        private service: CourseEqualizationService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() id: number;
    @Input() decisionOptions: IClassifier[] = [];

    decision: IClassifier;
    comment: string;

    get protocolWarning(): string {
        const url = this.service.getProtocolUrl(this.id);
        return this.app.translate('courseEqualization_protocolWarning').replace('{{url}}', url);
    }

    get isCommentRequired() {
        return this.decision?.Code == 'PassPartial' || this.decision?.Code == 'Other';
    }

    ok() {
        this.activeModal.close({
            decision: this.decision,
            comment: this.comment
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
